var v = 2, A = 17, E = 3, _ = "0-9０-９٠-٩۰-۹", F = "-‐-―−ー－", u = "／/", a = "．.", S = "  ­​⁠　", r = "()（）［］\\[\\]", c = "~⁓∼～", N = "".concat(F).concat(u).concat(a).concat(S).concat(r).concat(c), T = "+＋";
export {
  E as MAX_LENGTH_COUNTRY_CODE,
  A as MAX_LENGTH_FOR_NSN,
  v as MIN_LENGTH_FOR_NSN,
  T as PLUS_CHARS,
  _ as VALID_DIGITS,
  N as VALID_PUNCTUATION,
  S as WHITESPACE
};
